/*
 Copied from portis: packages/portis-crypto/src/enums/encryptionType.ts
 */
export enum EncryptionType {
  AesCbc256_HmacSha256_B64 = 2,
}
